const API_BASE_URL = 'https://viron.network/api';
// const API_BASE_URL = 'http://localhost:3001/api';


// export default API_BASE_URL;
// https://148.113.201.173:4000/edit-account

const ADMIN_BASE_URL = 'https://viron.network';
// const ADMIN_BASE_URL = 'http://localhost:3000';



export { API_BASE_URL, ADMIN_BASE_URL };

